<!--
  @description dashBoard 查看
  @author xiehan
  @date 2018/12/27
-->
<style>
</style>

<template>
  <div class="dashboardDetail__content">
    <g-back :history="history"></g-back>
    <div class="ilb"
      v-show="timeType !== 'ABSOLUTE'">
      <el-form label-width='68px'>
        <el-form-item :label="$t('dashBoard.refreshRate')"
          input-width="180px">
          <g-select :list="intervalTimeList"
            v-model="intervalTime"
            @change="setTimer"></g-select>
        </el-form-item>
      </el-form>
    </div>
    <el-popover placement="bottom-start"
      trigger="click"
      width="640"
      v-model="showTime">
      <el-tabs tab-position="left">
        <el-tab-pane label="Quick">
          <el-button v-for="(item, key) in select_time"
            type="text"
            v-text="item"
            :key="item"
            @click="chooseQuickTime(key)"></el-button>
        </el-tab-pane>
        <el-tab-pane label="Absolute">
          <el-form ref="searchForm"
            :model="searchForm"
            :inline="true">
            <el-form-item :label="$t('common.time')"
              input-width="auto">
              <el-form-item prop="startTime">
                <el-date-picker value-format="timestamp"
                  style="width: 180px;"
                  v-model="searchForm.startTime"
                  type="datetime">
                </el-date-picker>
              </el-form-item>
              <span v-text="$t('common.to')"></span>
              <el-form-item prop="endTime"
                style="margin-left: 10px">
                <el-date-picker value-format="timestamp"
                  style="width: 180px;"
                  v-model="searchForm.endTime"
                  type="datetime">
                </el-date-picker>
              </el-form-item>
            </el-form-item>
            <el-button type="primary"
              @click="searchAbsoluteTime"
              v-text="$t('common.search')"></el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <el-button type="primary"
        slot="reference"
        v-text="choosenTime"></el-button>
    </el-popover>
    <el-button type="primary"
      v-g-rac="gRac('dashBoardDetail@saveTime')"
      @click="saveTime"
      v-text="$t('dashBoard.saveTime')"></el-button>
    <div class="mt-base">
      <chart-list :chart-data-list="chartDataList"
        :clickable="false"
        :resizeable="false"
        :dragable="false"></chart-list>
    </div>
  </div>
</template>
<script>
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import dashBoardBiz from "@/logic/intelligentMonitor/dashBoardBiz";
import ITDeviceMonitorBiz from "@/logic/intelligentMonitor/ITDeviceMonitorBiz";
import chartList from "@/components/chart/chart-dashboard-list";
import FilterData from "@/logic/intelligentMonitor/viewDataHelper";
import ViewBiz from "@/logic/intelligentMonitor/viewBiz";
import { extend } from "@/utils/tool";
import TimeFormat from "@/utils/timeFormat";
const filterData = new FilterData();
let seriesColor = [
  "#0B8DE5",
  "#43CD80",
  "#40E0D0",
  "#FFEC8B",
  "#FFA07A",
  "#FF69B4",
  "#FF0000",
  "#CDC9C9",
  "#DEB887",
  "#AB82FF",
  "#B8860B",
  "#87CEEB",
  "#8FBC8F",
  "#B4EEB4",
  "#CD5B45",
  "#F08080"
];

export default {
  mixins: [rac, dic],
  components: {
    chartList
  },
  data() {
    return {
      history: [],
      showTime: false,
      select_time: {},
      searchForm: {
        startTime: new Date(new Date().toLocaleDateString()).getTime(),
        endTime: ""
      },
      chartDataList: [],
      viewList: [],
      viewStyle: null,
      choosenTime: this.$t("dashBoard.today"),
      timeType: "",
      intervalTimeList: {
        "1": this.$t("dashBoard._1minute"),
        "5": this.$t("dashBoard._5minutes"),
        "10": this.$t("dashBoard._10minutes"),
        "30": this.$t("dashBoard._30minutes"),
        close: this.$t("dashBoard.close")
      },
      intervalTime: "1",
      timer: null
    };
  },
  watch: {
    $route(to, from) {
      if (to.name === "dashBoardDetail" && from.name === "dashBoard") {
        this.intervalTime = "1";
        this.resetColor();
        this.resetChart();
        this.waitTime();
      } else if (from.name === "dashBoardDetail") {
        this.clearTimer();
      } else if (to.name === "dashBoardDetail") {
        if (this.timeType === "QUICK") {
          let key = Object.keys(this.select_time).filter(
            item => this.choosenTime === this.select_time[item]
          )[0];
          this.chooseQuickTime(key);
        }
      }
    }
  },
  methods: {
    setHistory(name) {
      this.history = [];
      this.history.push({ name: name });
    },
    async waitTime(searchObj, type) {
      await this.dGetDictionaryByCode("quicktimetype");
      this.select_time = { ...this.dDictionary.quicktimetype };
      this.getDashById(searchObj, type);
    },
    resetColor() {
      seriesColor = [
        "#0B8DE5",
        "#43CD80",
        "#40E0D0",
        "#FFEC8B",
        "#FFA07A",
        "#FF69B4",
        "#FF0000",
        "#CDC9C9",
        "#DEB887",
        "#AB82FF",
        "#B8860B",
        "#87CEEB",
        "#8FBC8F",
        "#B4EEB4",
        "#CD5B45",
        "#F08080"
      ];
    },
    resetChart() {
      this.viewStyle = null;
      this.viewList = [];
      this.chartDataList = [];
    },
    getDashById(searchObj, type) {
      let param = {
        id: this.$route.query.id,
        data: searchObj,
        type: type
      };
      dashBoardBiz.findBoardById({ ...param }).then(data => {
        let alarmChange = false;
        // 判断告警状态是否更新
        if (this.viewList.length) {
          let oriIdList = this.viewList.map(item => item["id"]);
          let newIdList = data.viewList.map(item => item["id"]);
          let oriAlarmList = this.viewList.map(item => item["alarm"]);
          let newAlarmList = data.viewList.map(item => item["alarm"]);
          if (
            oriIdList.toString() !== newIdList.toString() ||
            oriAlarmList.toString() !== newAlarmList.toString()
          ) {
            alarmChange = true;
          }
        }
        // 如果是初始化或者更新了就重新渲染 否则 只是插入数据
        if (this.viewList.length === 0 || alarmChange) {
          this.resetChart();
          this.setHistory(data.name);
          this.viewStyle = data.style;
          this.viewList = data.viewList;
          if (data.dashTimerFormat) {
            this.timeType = data.dashTimerFormat.type;
            if (this.timeType === "ABSOLUTE") {
              this.choosenTime = `${TimeFormat.getFormatTime(
                data.dashTimerFormat.data.startTime
              )}
                ${this.$t("common.to")}${TimeFormat.getFormatTime(
                data.dashTimerFormat.data.endTime
              )}`;
              this.clearTimer();
            } else {
              this.choosenTime = this.select_time[
                data.dashTimerFormat.data.format
              ];
              this.setTimer();
            }
            this.setChartData({
              startTime: data.startTime,
              endTime: data.endTime
            });
          } else {
            this.timeType = "ABSOLUTE";
            this.searchForm.startTime = new Date(
              new Date().toLocaleDateString()
            ).getTime();
            this.searchForm.endTime = "";
            this.choosenTime = `${TimeFormat.getFormatTime(
              this.searchForm.startTime
            )}
              ${this.$t("common.to")}${TimeFormat.getFormatTime(
              new Date().getTime()
            )}`;
            this.setChartData();
            this.clearTimer();
          }
        } else {
          this.timeType = type;
          this.showTime = false;
          this.choosenTime =
            type === "ABSOLUTE"
              ? `${TimeFormat.getFormatTime(data.startTime)}
            ${this.$t("common.to")}${TimeFormat.getFormatTime(data.endTime)}`
              : this.select_time[searchObj.format];
          this.viewList.map((item, index) => {
            let rowInfo = extend(true, {}, item);
            if (rowInfo.extend.group !== "others") {
              this.getDefaultData(rowInfo, {
                startTime: data.startTime,
                endTime: data.endTime
              }).then(res => {
                this.chartDataList.splice(index, 1, res);
              });
            }
          });
        }
      });
    },
    setChartData(time) {
      let promiseList = [];
      this.viewList.map((item, index) => {
        if (!item.extend.style) {
          item.extend.style = {};
          for (let i in this.viewStyle[item.id]) {
            item.extend.style[i] =
              String(this.viewStyle[item.id][i]).indexOf("px") > -1
                ? Number(this.viewStyle[item.id][i].split("px")[0])
                : Number(this.viewStyle[item.id][i]);
          }
        }
        let rowInfo = extend(true, {}, item);
        if (item.extend.group === "others") {
          promiseList.push(this.getOthersData(rowInfo));
        } else {
          promiseList.push(this.getDefaultData(rowInfo, time));
        }
      });
      Promise.all(promiseList).then(res => {
        res.map(item => {
          this.chartDataList.push(item);
        });
      });
    },
    getOthersData(chartInfo) {
      return new Promise((resolve, reject) => {
        ViewBiz.getSourceData({
          id: chartInfo.dataSources.id
        }).then(data => {
          if (data.resultCode && data.resultCode !== "00000000") {
            this.$message({
              message: `${this.$t("view.dataSourceError")}: ${data.resultDesc}`,
              type: "error"
            });
          } else {
            let dataList = this.handlerOthersData(chartInfo, data);
            resolve(this.translateChartFormat(chartInfo, dataList));
          }
        });
      });
    },
    handlerOthersData(chartInfo, data) {
      filterData.filterDataByName(data, chartInfo.param.x.field);
      let timeList = filterData.getFilterDataList();
      let dataList = [];
      let yObj = {};
      chartInfo.param.y.map((item, index) => {
        filterData.filterDataByName(data, item.field);
        yObj[this.splitField(item.field)] = filterData.getFilterDataList();
      });
      timeList.map((item, index) => {
        let pushObj = {};
        pushObj[this.splitField(chartInfo.param.x.field)] = item;
        for (let i in yObj) {
          pushObj[i] = yObj[i][index];
        }
        dataList.push(pushObj);
      });
      return dataList;
    },
    getDefaultData(chartInfo, time) {
      return new Promise((resolve, reject) => {
        let requestData = {
          appName: chartInfo.extend.appName,
          group: chartInfo.extend.group,
          kpiKey: chartInfo.extend.kpiKey,
          startTime: time
            ? time.startTime
            : new Date(new Date().toLocaleDateString()).getTime(),
          endTime: time ? time.endTime : new Date().getTime(),
          siteCode: chartInfo.extend.siteCode
        };
        if (chartInfo.extend.isSeries)
          requestData.groupField = this.splitField(chartInfo.param.series);
        ITDeviceMonitorBiz.getAllChartData(requestData).then(data => {
          let seriesDataList = this.handlerDefaultData(chartInfo, data);
          resolve(this.translateChartFormat(chartInfo, seriesDataList));
        });
      });
    },
    handlerDefaultData(chartInfo, data) {
      let seriesDataList = data.data;
      if (chartInfo.extend.isSeries) {
        seriesDataList = [];
        if (data.data && data.data.length > 0) {
          data.data[0].value.map((item, index) => {
            let pushObj = {};
            pushObj[this.splitField(chartInfo.param.x.field)] =
              data.data[0][this.splitField(chartInfo.param.x.field)][index];
            seriesDataList.push(pushObj);
          });
          // 转换默认数据源结构
          data.data.map((dataItem, dataIndex) => {
            dataItem[this.splitField(chartInfo.param.y[0].field)].map(
              (yItem, yIndex) => {
                if (seriesDataList[yIndex])
                  seriesDataList[yIndex][
                    dataItem[this.splitField(chartInfo.param.series)]
                  ] = yItem;
              }
            );
          });
          // 重新设置y轴的数据
          let yAxis = [];
          data.data.map((dataItem, dataIndex) => {
            yAxis.push({
              name: dataItem[this.splitField(chartInfo.param.series)],
              field: dataItem[this.splitField(chartInfo.param.series)]
            });
          });
          chartInfo.param.y = [...yAxis];
        }
      }
      return seriesDataList;
    },
    translateChartFormat(chartInfo, data) {
      let columns = [];
      columns.push(this.splitField(chartInfo.param.x.field));
      chartInfo.param.y.map(item => {
        columns.push(
          chartInfo.extend.isSeries ? item.field : this.splitField(item.field)
        );
      });
      let colors = chartInfo.extend.colorList
        ? chartInfo.extend.colorList
        : [...seriesColor];
      let style = chartInfo.extend.style
        ? chartInfo.extend.style
        : {
            height: 262,
            width: 402
          };
      let chartObj = {
        title: chartInfo.name,
        chartId: `${chartInfo.id}`,
        style: style,
        type: chartInfo.type.toUpperCase(),
        chartData: {
          colors: colors.splice(0, columns.length - 1),
          rows: data,
          columns: columns,
          xName: chartInfo.param.x.name,
          alarm: !!chartInfo.alarm,
          formatMap: {},
          labelMap: {}
        }
      };
      if (chartInfo.extend.isSeries) {
        chartObj.chartStyle = {
          grid: {
            left: "4%",
            bottom: chartInfo.param.x.name ? "12%" : "6%",
            top: "18%",
            right: "6%",
            containLabel: true
          },
          legend: {
            type: "scroll",
            width: "70%",
            top: "4%",
            data: columns.filter((item, index) => index > 0)
          }
        };
      } else if (chartInfo.param.x.name) {
        chartObj.chartStyle = {
          grid: {
            left: "4%",
            bottom: "12%",
            top: "10%",
            right: "6%",
            containLabel: true
          }
        };
      }
      if (columns[0].toLowerCase().indexOf("time") > -1) {
        chartObj.chartData.formatMap[columns[0]] = "TIME";
      }
      chartInfo.param.y.map((item, index) => {
        if (item.name) {
          chartObj.chartData.labelMap[
            chartInfo.extend.isSeries ? item.field : this.splitField(item.field)
          ] =
            item.name;
        }
      });
      return chartObj;
    },
    splitField(str) {
      if (str.indexOf(".") > -1) {
        return str.split(".")[str.split(".").length - 1];
      }
      return str;
    },
    chooseQuickTime(key) {
      this.searchTime(
        {
          format: key
        },
        "QUICK"
      );
      this.setTimer();
    },
    searchAbsoluteTime() {
      let searchObj = extend(true, {}, this.searchForm);
      if (!searchObj.endTime) searchObj.endTime = new Date().getTime();
      this.searchTime(searchObj, "ABSOLUTE");
      this.clearTimer();
    },
    searchTime(searchObj, type) {
      this.resetColor();
      this.waitTime(searchObj, type);
    },
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    setTimer() {
      this.clearTimer();
      if (this.intervalTime !== "close") {
        this.timer = setTimeout(() => {
          let key = Object.keys(this.select_time).filter(
            item => this.choosenTime === this.select_time[item]
          )[0];
          this.chooseQuickTime(key);
          this.setTimer();
        }, Number(this.intervalTime) * 60 * 1000);
      }
    },
    saveTime() {
      let saveObj = {
        dashId: this.$route.query.id,
        type: this.timeType
      };
      if (this.timeType === "QUICK") {
        saveObj.data = {
          format: Object.keys(this.select_time).filter(
            item => this.choosenTime === this.select_time[item]
          )[0]
        };
      } else {
        saveObj.data = {
          startTime: TimeFormat.formatTimeTolong(
            this.choosenTime.split(this.$t("common.to"))[0]
          ),
          endTime: TimeFormat.formatTimeTolong(
            this.choosenTime.split(this.$t("common.to"))[1]
          )
        };
      }
      dashBoardBiz.setDashTimer(saveObj).then(data => {
        this.$message({
          message: this.$t("common.success"),
          type: "success"
        });
      });
    }
  },
  mounted() {
    this.waitTime();
  }
};
</script>